import React, { Component, PropTypes } from 'react';

const styles = {
  root: {
    verticalAlign: 'top',
    position: 'relative',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'inline-block',
  },
  image: {
    display: 'none'
  }
};

class ResponsiveImage extends Component {
  static displayName = 'ResponsiveImage';

  static propTypes = {
    src: PropTypes.string,
    size: PropTypes.number,
    fallback: PropTypes.string,
    style: PropTypes.object,
    contain: PropTypes.bool,
    children: PropTypes.node,
    opacity: PropTypes.number,
    raw: PropTypes.bool
  };

  static defaultProps = {
    contain: false,
    opacity: 1,
    size: 512,
    fallback: 'r.s.coursio.com/cache',
    raw: false
  };

  constructor() {
    super(...arguments);
    this.state = {
      errored: false,
      src: this.props.src.endsWith('gif') ? this.props.src : this.resize(this.props.src)
    };
  }

  componentWillReceiveProps(next, current) {
    if (next.src !== this.props.src) {
      this.setState({ src: this.resize(next.src)})
    }
    if (next.raw !== this.props.raw) {
      this.setState({ src: this.resize(next.src, next.raw)})
    }
  }

  getRootStyle = () => {
    const { contain, style, opacity } = this.props;
    return Object.assign(
      {},
      styles.root,
      {
        width: '100%',
        opacity,
        objectFit: contain ? 'contain' : 'cover',
      },
      style
    );
  }

  handleError = (altrSrc) => {
    if (this.state.errored) {
      return;
    }
    const tokens = this.state.src ? this.state.src.split('/') : altrSrc.split('/');
    tokens[2] = this.props.fallback;
    let src = tokens.join('/');
    if(src.includes('/cache/files/')){
      src = src.replace('/files', '')
    }
    this.setState({ errored: true, src });
  };

  resize = (url, nextRaw) => {
    if (nextRaw !== undefined ? !nextRaw : !this.props.raw) {
      const { size } = this.props;
      const tokens = url.split('.');
      let extension = tokens.pop();
      if (extension.length > 4) {
        tokens.push(extension);
        return tokens.join('.') + '-' + size;
      }
      return tokens.join('.') + '-' + size + '.' + extension;
    }
  };

  render() {
    const { src, children, ...other } = this.props;
    return (
      <div>
        <img
          {...other}
          style={this.getRootStyle()}
          onError={() => this.handleError(src)}
          src={this.state.src || src}
        />
        {children}
      </div>
    );
  }
}

export default ResponsiveImage;



// WEBPACK FOOTER //
// ./src/js/components/ResponsiveImage.js